class MWF_Newsletter {
    constructor () {
        if (!$('.mwf-newsletter-form').length) {
            return;
        }

        this.readUtmFromCookies();
    }

    readUtmFromCookies () {
        let form = $('.mwf-newsletter-form');
        
        if (!form.length) {
            return;
        }

        if (!window.mwfUtmData) {
            return;
        }

        let utmSource = window.mwfUtmData.utm_source;
        let utmMedium = window.mwfUtmData.utm_medium;
        let utmCampaign = window.mwfUtmData.utm_campaign;
        let utmContent = window.mwfUtmData.utm_content;

        if (utmSource) {
            form.find('input[name="utm_source"]').val(utmSource);
            form.find('input.enchagre-form-v2[name="UTMSource"]').val(utmSource);
        }

        if (utmMedium) {
            form.find('input[name="utm_medium"]').val(utmMedium);
            form.find('input.enchagre-form-v2[name="UTMMedium"]').val(utmMedium);
        }

        if (utmCampaign) {
            form.find('input[name="utm_campaign"]').val(utmCampaign);
            form.find('input.enchagre-form-v2[name="UTMCampaign"]').val(utmCampaign);
        }

        if (utmContent) {
            form.find('input[name="utm_content"]').val(utmContent);
            form.find('input.enchagre-form-v2[name="UTMContent"]').val(utmContent);
        }
    }
}